import { CSSProperties } from "react";

export const XMeapleSlotSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg width={width} height={width} viewBox="0 0 32 33" style={style}>
      <g filter="url(#filter0_i_213_818)">
        <path
          d="M13.2281 32.052L16.0239 25.4619V0C12.8287 0 10.4323 4.19372 10.8317 7.98804C2.94349 9.78535 -0.451396 12.4813 0.0478471 14.3785C0.556064 16.3097 3.9753 17.4073 5.93902 17.6735C5.93902 20.7689 1.84515 25.4619 1.04636 28.058V32.052H13.2281Z"
          fill="#C2C2C2"
          fillOpacity="0.24"
        />
        <path
          d="M18.7719 32.052L15.9761 25.4619V0C19.1713 0 21.5677 4.19372 21.1683 7.98804C29.0565 9.78534 32.4514 12.4813 31.9522 14.3785C31.4439 16.3097 28.0247 17.4073 26.061 17.6735C26.061 20.7689 30.1548 25.4619 30.9536 28.058V32.052H18.7719Z"
          fill="#C2C2C2"
          fillOpacity="0.24"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_213_818"
          x="0"
          y="0"
          width="32"
          height="32.052"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0.37 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_213_818"
          />
        </filter>
      </defs>
    </svg>
  );
};
